import React from 'react';
import classNames from 'classnames';

const ChildrenCourseNav = (props) => {
  const { current, currentChild, content, onChange, onChildChange } = props;

  const haveChildrenWithTags = [];
  let _item = null;
  if (current) {
    _item = content.find(it => it.id === current);
  }
  if (_item) {
    _item.children.forEach(it => {
      if (it.children.length && it.children[0].tag) {
        haveChildrenWithTags.push(it);
      }
    });
  }
  if (!haveChildrenWithTags.length) return <></>;

  let tabs = content
    .find(item => item.id === current).children
    .filter(item => !!item.children.length)
    .map(childItem => {
      return (
        <div
          key={childItem.id}
          onClick={() => onChildChange(childItem.id)}
          className={classNames(
            'popup-nav__children-tabs-tab',
            childItem.id === currentChild && _item.id === current ? 'active' : ''
          )}
        >
          {childItem.name}
        </div>
      );
    });

  tabs = [
    <div
      key={'undefined'}
      onClick={() => onChange(_item.id)}
      className={classNames(
        'popup-nav__children-tabs-tab',
        !currentChild ? 'active' : ''
      )}
    >Все</div>,
    ...tabs
  ];

  return (
    <div
      className={classNames('popup-nav__children-tabs')}
    >{tabs}</div>
  );
};

export default ChildrenCourseNav;
